
import { Button, Col, Form, Icon, Row, Spin, Table } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import iconStyle from '../components/icon.cs';
import { getStringSorter, getBooleanSorter } from '../utils/antUtils';
import { getPageSize } from '../utils/paging';
import styles from './user.css';
import { editUser, fetchUsers, loginUser } from './userActions';
import UserModal from './userModalComponent';


const { Column } = Table;


class UserComponent extends Component {

  componentDidMount() {
    this.props.dispatch(fetchUsers(this.props.match.params.id));    
  }

  newUser = () => {
    let user = { id: -1, email: '', password: '', firstName: '', lastName: '' };
    this.props.dispatch(editUser(user));
  }

  loginAsUser = (user, e) => {
    e.preventDefault();
    e.stopPropagation();
  
    this.props.dispatch(loginUser(user));
  }

  render() {
    let data = this.props.list || [];
    const onRow = (edit) => ({
      onClick: () => {
        let clone = Object.assign({}, edit)
        this.props.dispatch(editUser(clone));
      }
    });

    const renderLoginButton = (user) => <Button onClick={(e) => this.loginAsUser(user, e)}>Logga in som användare</Button>

    return (<div>

      <UserModal />

      <Row style={{ marginBottom: 20 }}>
        <Col span={12}>
          <h2>{this.props.orgName} användare</h2>
        </Col>
        <Col span={12}>
          <Button type='primary' icon='plus' size='large' onClick={this.newUser} style={{ float: 'right' }}>Ny användare</Button>
        </Col>
      </Row>

      <Spin spinning={this.props.loading}>
        <Table dataSource={data} size='small' pagination={{ pageSize: getPageSize(), position: 'bottom' }} onRow={onRow} style={styles.table} >
          <Column title=" " width={15} render={() => (<Icon type='user' style={iconStyle} />)} />
          <Column title="E-post" width={320} dataIndex="email" key="email" sorter={getStringSorter('name')} />
          <Column title="Förnamn" defaultSortOrder='ascend' width={250} dataIndex="firstName" key="firstName" sorter={getStringSorter('firstName')} />
          <Column title="Efternamn" dataIndex="lastName" key="lastName" sorter={getStringSorter('lastName')} />
          <Column title="Utgångsdatum" dataIndex="expiryDate" key="expiryDate" sorter={getStringSorter('expiryDate')} />
          <Column title="Kund Admin" dataIndex="admin" key="admin" sorter={getBooleanSorter('admin')} render={ value => value? 'Ja' : 'Nej'} />
          <Column title="Rättsfall plus" dataIndex="featureSbtPlus" key="featureSbtPlus" sorter={getBooleanSorter('featureSbtPlus')} render={ value => value? 'Ja' : 'Nej'} />
          <Column title="Aktiv" dataIndex="enabled" key="enabled" sorter={getBooleanSorter('enabled')} render={ value => value? 'Ja' : 'Nej'} />
          <Column title="Logga In" dataIndex="id" key="id" render={(user) => renderLoginButton(user)} />
        </Table>
      </Spin>

    </div>)
  }
}

const mapStateToProps = (state) => {
  return {
    orgId: state.user.orgId,
    orgName: state.user.orgName,
    list: state.user.list,
    loading: state.user.loading,
    filter: state.user.filter
  }
};

export default connect(mapStateToProps)(Form.create()(UserComponent));


// WEBPACK FOOTER //
// ./src/user/userComponent.js